<script setup lang="ts">
import type { FavoriteButtonProps } from '~/utils/button'
import { faBookmark, faLockKeyhole } from '@fortawesome/pro-light-svg-icons'
import { faBookmark as faSolidBookmark } from '@fortawesome/pro-solid-svg-icons'

withDefaults(
  defineProps<FavoriteButtonProps>(),
  {
    intent: 'filled',
    layout: 'list',

  },
)

const hasLicense = useHasLicense()
</script>

<template>
  <button
    :id="`favorite-btn-${selected ? 'remove' : 'add'}`"
    :class="[
      buttonVariants.favorite.base({ type, selected, intent, layout }),
      !hasLicense && layout === 'reading' && 'disabled:opacity-50',
    ]"
    :disabled="!hasLicense"
    v-bind="$attrs"
  >
    <Icon v-if="!hasLicense && layout === 'list'" :icon="faLockKeyhole" />
    <Icon v-else :icon="selected ? faSolidBookmark : faBookmark" />
    <slot v-if="$slots.label" name="label" />
  </button>
</template>
